<template>
  <div class="customerAddresses">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">{{ util.language('客户地址', 'Customer\'s address') }}</el-text>
      <el-text style="font-size: small; color: #909399;">{{ data.customer.code + ' ' + data.customer.name }}</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item>
        <el-button-group>
          <el-button @click="router.go(-1)">{{ util.language('返回', 'Back') }}</el-button>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('刷新', 'Refresh') }}</el-button>
          <!-- <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button> -->
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">{{ util.language('新增', 'New') }}</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">{{ util.language('详情', 'Detail') }}</el-button>
          <el-button type="danger" :disabled="show.selected.length < 1" @click="del()">{{ util.language('删除', 'Delete') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.customerAddressList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="70" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="contact" :label="util.language('联系人', 'Contact')" width="200" show-overflow-tooltip />
      <el-table-column prop="phone" :label="util.language('电话号', 'Phone')" width="150" show-overflow-tooltip />
      <el-table-column prop="addressDetail" :label="util.language('详细地址', 'Address')" min-width="100" show-overflow-tooltip />
      <el-table-column :label="util.language('创建时间', 'Create time')" width="160" show-overflow-tooltip>
        <template #default="scope">
          <el-text>{{ util.parseTime(scope.row.createDatetime) }}</el-text>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const pageParam = cache.getObject(cache.keys.pageParam + "customerAddresses")
if (!pageParam) {
  router.go(-1)
  // return
}

const data = reactive({
  customer: JSON.parse(JSON.stringify(pageParam)),
  customerAddressList: [],
})

const loading = reactive({
  find: false,
})

const show = reactive({
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.customerId = data.customer.id
}
resetSearchParam()

const commitFindList = () => {
  loading.find = true
  api.get('/backend/customer/getCustomerAddressList', { params: searchParam }).then(res => {
    data.customerAddressList = res.list
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'customerAddress', { customerId: data.customer.id })
  router.push('/customerAddress')
}

const update = (row) => {
  const customerAddress = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'customerAddress', customerAddress)
  router.push('/customerAddress')
}

const del = () => {
  const customerAddressList = tabRef.value.getSelectionRows()
  const ids = customerAddressList.map(address => address.id).filter(id => id != null)
  ElMessageBox.confirm('', {
    title: util.language('确认删除', 'Delete confirm'),
    message: util.language('将要删除 ' + ids.length + ' 个地址。', 'Will delete ' + ids.length + ' addresses.'),
    autofocus: false,
    confirmButtonText: util.language('删除', 'Delete'),
    cancelButtonText: util.language('取消', 'Cancel'),
  }).then(() => {
    api.post('/backend/customer/delCustomerAddress', { ids: ids }).then(res => {
      ElMessage.success(util.language('删除成功', 'Success'))
      commitFindList()
    })
  })

}

</script>

<style lang="less"></style>